import { HexColor } from '@repo/shared/types';
import { groq } from 'next-sanity';
import { z } from 'zod';

import { SanityBasicText } from './basicText';
import { button, SanityButton } from './button';
import { image, SanityImage } from './image';
import { mediaWithVideoEmbed, SanityMediaWithVideoEmbed } from './media';
import { richText } from './richText';

export const SanityTwoUp = z.object({
  sectionIndex: z.number().optional().nullable(),
  _type: z.literal('twoUp'),
  _key: z.string(),
  theme: z.enum(['light', 'dark', 'charcoal', 'purple']),
  useLogoAsOverline: z.boolean().optional().nullable(),
  overline: z.string().optional().nullable(),
  overlineLogo: SanityImage.optional().nullable(),
  overlineLogoWidth: z.number().optional().nullable(),
  headline: z.string(),
  bodyCopy: z.string().optional().nullable(),
  formattedBodyCopy: SanityBasicText.optional().nullable(),
  cta: SanityButton,
  media: SanityMediaWithVideoEmbed,
  background: HexColor.nullable(),
  desktopLayout: z.enum(['imageText', 'textImage']),
  mobileLayout: z.enum(['imageText', 'textImage']),
  details: z
    .array(
      z.object({
        _key: z.string(),
        title: z.string(),
        caption: z.string(),
      }),
    )
    .optional()
    .nullable(),
});
export type SanityTwoUp = z.infer<typeof SanityTwoUp>;

export const twoUp = groq`{
    "theme": select(theme == "dark" => "charcoal", coalesce(theme, "light")),
    useLogoAsOverline,
    overline,
    overlineLogo ${image},
    overlineLogoWidth,
    headline,
    bodyCopy,
    formattedBodyCopy[] ${richText},
    cta ${button},
    media[0] ${mediaWithVideoEmbed},
    'background': background->color.hex,
    desktopLayout,
    mobileLayout,
    details[] {
      _key,
      title,
      caption,
    }
}`;
